import { CreateUpdateTemplateFormValues, TemplateDetails } from "../supplierPosSettingsTypes"
import { LanguageCode } from "../../termsAndConditions/termsAndConditionTypes"

export const prepareInitialValues = (template?: TemplateDetails): CreateUpdateTemplateFormValues => {
    return {
        name: template?.name ?? "",
        languageCode: template?.languageCode ?? LanguageCode.DA,
        layout: {
            theme: {
                id: template?.layout?.theme?.id ?? undefined,
            },
        },
        content: {
            centerContent: {
                purchaseButton: {
                    label: template?.content?.centerContent?.purchaseButton?.label ?? "",
                },
                subtitle: {
                    label: template?.content?.centerContent?.subtitle?.label ?? "",
                },
                title: {
                    label: template?.content?.centerContent?.title?.label ?? "",
                },
            },
            shortcuts: {
                helpCenter: template?.content?.shortcuts?.helpCenter ?? true,
                downloadApp: template?.content?.shortcuts?.downloadApp ?? true,
            },
        },
    }
}
